export default __webpack_public_path__ + "static/media/dogAndMan.25d9bb74.png";